import { useEffect, useState } from "react";

function DataStatus({ status }) {
  const [blink, setBlink] = useState(true);

  useEffect(() => {
    if (status?.toLowerCase() === "running") {
      const interval = setInterval(() => {
        setBlink((prev) => !prev);
      }, 500);

      return () => clearInterval(interval);
    }
  }, [status]);

  const getClassName = () => {
    switch (status?.toLowerCase()) {
      case "planned":
        return "badge border border-success text-success  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center";
      case "completed":
        return "badge border border-secondary text-inverse  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center";
      case "cancel":
        return "badge border border-danger text-danger  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center";
      case "reschedule":
        return "badge border border-warning text-warning  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center";
      case "running":
        return blink
          ? "badge  border bg-success text-inverse  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center"
          : "badge border border-secondary text-inverse  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center";
      default:
        return "";
    }
  };

  return (
    <td className={`align-middle`}>
      <span className={`${getClassName()}`}>{status}</span>
    </td>
  );
}

export default DataStatus;
